import React from 'react'
import {Box, Text} from 'grommet'
import {Tabs, TabsProps} from 'antd'
import {SendContent} from "./SendContent";
import {ReceiveContent} from "./ReceiveContent";

export const SendPage = () => {
  const items: TabsProps['items'] = [
    {
      key: 'send',
      label: 'Send',
      children: <SendContent />,
    },
    {
      key: 'receive',
      label: 'Receive',
      children: <ReceiveContent />,
    }
  ];

  const onChange = () => {

  }

  return <Box pad={'52px 32px'} width={'100%'}>
    <Box>
      <Text size={'42px'}>Send & Receive</Text>
    </Box>
    <Box margin={{ top: '60px' }} align={'center'}>
      <Box
        background={'#323232'}
        pad={'12px 24px 32px'}
        round={'28px'}
        width={'500px'}
      >
        <Tabs size={'large'} defaultActiveKey="1" items={items} onChange={onChange} />
      </Box>
    </Box>
  </Box>
}
